import { BackendHttpService } from '../../../services/backendHttpService';
import { PersonProfileCompletionDto } from '../types/profileCompletion';

export class ProfileCompletionService extends BackendHttpService {
    constructor() {
        super('ProfileCompletion');
    }

    async getByPersonId(personId: number): Promise<PersonProfileCompletionDto | null> {
        try {
            return await this.get<PersonProfileCompletionDto>(`/getByPersonId/${personId}`);
        } catch (error: any) {
            if (error?.message?.includes('404') || error?.status === 404) {
                return null;
            }
            console.error(`Error fetching profile completion for person ${personId}:`, error);
            throw error;
        }
    }

    async calculate(personId: number): Promise<PersonProfileCompletionDto> {
        return await this.post<object, PersonProfileCompletionDto>({}, `/calculate/${personId}`);
    }
}
